import { untrack } from 'solid-js';
import { getFieldStore } from '../utils';
/**
 * Focuses the specified field of the form.
 *
 * @param form The form of the field.
 * @param name The name of the field.
 */
export function focus(form, name) {
    untrack(() => getFieldStore(form, name)?.elements.get()[0]?.focus());
}
